// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extract-group-member{

}

.extract-group-member .search-tools{
    display: flex;
    flex-wrap:wrap ;
}

.extract-group-member .search-tools .search-bar{
    background-color: white;
    width: 260px;
    max-width: 100%;
    padding: 1px 12px;
    border-radius: 22px;
    margin: 0px 10px;
}

@media(max-width:600px){
    .extract-group-member .search-tools .search-bar{
        margin-bottom: 16px;
    }
    .extract-group-member .load-responsive{
        width: 120px !important;
        margin-right: 10px;
    }
    
}


.extract-group-member .search-tools .search-bar-active{
    border: 1px solid var(--main-color);
}

.extract-group-member .search-tools .search-bar input{
    width: 90%;
    border: none;
}

.extract-group-member .search-tools .search-bar input:focus{
    outline: none;
}

.extract-group-member .search-tools .search-bar svg{
    color: var(--gray-color);
}

.extract-group-member .search-tools .search-btn-extract {
    color: white;
    font-weight: bold;
    background-color: var(--main-color);
    padding: 8px 25px;
    border-radius: 22px;
    border: none;
    cursor: pointer;
}

.extract-group-member .main-tools{
    display: flex;
    justify-content: space-between;
    width: 800px;
    max-width: 100%;
}

.extract-group-member .search-tools .next-btn{
    background-color: var(--main-color);
    color: white;
    font-weight: bold;
    padding: 8px 22px;
    border: none;
    cursor: pointer;
    border-radius: 22px;
    margin:0px 10px ;
}

.extract-group-member .main-tools .extract-btn {
    background-color: var(--main-color);
    border-radius: 6px;
    color: white;
    font-weight: bold;
    font-size: 12px;
    border: none;
    padding: 8px 18px;
    cursor: pointer;
}




/* Start Table User */

.extract-group-member .all-member {
    margin-top:20px ;
    width: 600px;
    max-width: 100%;
    height: calc(100vh - 156px);
    overflow-y: scroll;
    padding: 8px 10px;
}
.extract-group-member .all-member .row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    padding: 8px 10px;
    border-radius: 7px;
    margin-top: 11px;
}

.extract-group-member .all-member .row input{
    cursor: pointer;
}

.extract-group-member .all-member .row .col{
    width: 200px;
    max-width: 100%;
}

.extract-group-member .all-member .row .check{
    width: 30px;
}

.extract-group-member .all-member .row .title-head{
    font-weight: bold;
}

.extract-group-member .all-member .row .profile-pic {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

/* End  Table User */`, "",{"version":3,"sources":["webpack://./src/Pages/ExtractGroupMember/extractgrpupmember.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;;AAEJ;;;AAGA;IACI,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mCAAmC;IACnC,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;;;;AAKA,qBAAqB;;AAErB;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA,oBAAoB","sourcesContent":[".extract-group-member{\n\n}\n\n.extract-group-member .search-tools{\n    display: flex;\n    flex-wrap:wrap ;\n}\n\n.extract-group-member .search-tools .search-bar{\n    background-color: white;\n    width: 260px;\n    max-width: 100%;\n    padding: 1px 12px;\n    border-radius: 22px;\n    margin: 0px 10px;\n}\n\n@media(max-width:600px){\n    .extract-group-member .search-tools .search-bar{\n        margin-bottom: 16px;\n    }\n    .extract-group-member .load-responsive{\n        width: 120px !important;\n        margin-right: 10px;\n    }\n    \n}\n\n\n.extract-group-member .search-tools .search-bar-active{\n    border: 1px solid var(--main-color);\n}\n\n.extract-group-member .search-tools .search-bar input{\n    width: 90%;\n    border: none;\n}\n\n.extract-group-member .search-tools .search-bar input:focus{\n    outline: none;\n}\n\n.extract-group-member .search-tools .search-bar svg{\n    color: var(--gray-color);\n}\n\n.extract-group-member .search-tools .search-btn-extract {\n    color: white;\n    font-weight: bold;\n    background-color: var(--main-color);\n    padding: 8px 25px;\n    border-radius: 22px;\n    border: none;\n    cursor: pointer;\n}\n\n.extract-group-member .main-tools{\n    display: flex;\n    justify-content: space-between;\n    width: 800px;\n    max-width: 100%;\n}\n\n.extract-group-member .search-tools .next-btn{\n    background-color: var(--main-color);\n    color: white;\n    font-weight: bold;\n    padding: 8px 22px;\n    border: none;\n    cursor: pointer;\n    border-radius: 22px;\n    margin:0px 10px ;\n}\n\n.extract-group-member .main-tools .extract-btn {\n    background-color: var(--main-color);\n    border-radius: 6px;\n    color: white;\n    font-weight: bold;\n    font-size: 12px;\n    border: none;\n    padding: 8px 18px;\n    cursor: pointer;\n}\n\n\n\n\n/* Start Table User */\n\n.extract-group-member .all-member {\n    margin-top:20px ;\n    width: 600px;\n    max-width: 100%;\n    height: calc(100vh - 156px);\n    overflow-y: scroll;\n    padding: 8px 10px;\n}\n.extract-group-member .all-member .row{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: white;\n    padding: 8px 10px;\n    border-radius: 7px;\n    margin-top: 11px;\n}\n\n.extract-group-member .all-member .row input{\n    cursor: pointer;\n}\n\n.extract-group-member .all-member .row .col{\n    width: 200px;\n    max-width: 100%;\n}\n\n.extract-group-member .all-member .row .check{\n    width: 30px;\n}\n\n.extract-group-member .all-member .row .title-head{\n    font-weight: bold;\n}\n\n.extract-group-member .all-member .row .profile-pic {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n/* End  Table User */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
